import Wind from "components/icons/Wind";

export const SensitiveDataEmptyState = () => {
  return (
    <div className="t-flex t-flex-1 t-min-h-[60dvh] t-w-full t-flex-col t-items-center t-justify-center t-gap-4 t-rounded-lg t-bg-surface-lighter-grey">
      <span className="t-text-neutral-40">
        <Wind width="20" height="20" />
      </span>
      <div className="t-flex t-flex-col t-items-center t-gap-1 t-text-center">
        <span className="t-text-subtext-sm t-text-text-60">
          No sensitive data stored
        </span>
        <span className="t-text-body-sm t-text-neutral-50 t-max-w-md">
          Sensitive information you add for this entity will be stored here and
          accessible securely when needed.
        </span>
      </div>
    </div>
  );
};
